import * as React from "react";

export function useLongPressDelete(ms = 500) {
  const [deleteTarget, setDeleteTarget] = React.useState<string | null>(null);
  const longPressTimerRef = React.useRef<number | null>(null);
  const longPressTriggeredRef = React.useRef(false);
  const squelchNextTapRef = React.useRef(false);

  const startLongPress = (key: string) => {
    longPressTriggeredRef.current = false;
    if (longPressTimerRef.current) window.clearTimeout(longPressTimerRef.current);
    longPressTimerRef.current = window.setTimeout(() => {
      longPressTriggeredRef.current = true;
      setDeleteTarget(key);
    }, ms);
  };

  const cancelLongPress = () => {
    if (longPressTimerRef.current) {
      window.clearTimeout(longPressTimerRef.current);
      longPressTimerRef.current = null;
    }
  };

  React.useEffect(() => () => cancelLongPress(), []);

  return {
    deleteTarget,
    setDeleteTarget,
    startLongPress,
    cancelLongPress,
    longPressTriggeredRef,
    squelchNextTapRef,
  };
}
